// @module NXTurn.ShoppingExtensions.LoginRegister
define('C3.ShoppingExtensions.PDP.Qty.ToolTip.View'
,	[
	  'c3_shoppingextensions_pdp_qty_tooltip.tpl'
	,   'Utils'
    ,   'LiveOrder.Model'
    ,   'GoogleTagManager'
    ,   'Tracker'
    ]
, function (
	   c3_shoppingextensions_pdp_qty_tooltip_tpl
    ,  Utils
    ,  LiveOrderModel
    ,  GoogleTagManager
    ,  Tracker
)
{
    'use strict';

	// @class NXTurn.ShoppingExtensions.LoginRegister.View @extends Backbone.View
	return Backbone.View.extend({

		template: c3_shoppingextensions_pdp_qty_tooltip_tpl

	,	initialize: function (options) {
		    this.options = options;
			//console.log(this.options)
			this.application = options.application;
			this.layout = options.layout;
			this.configuration = options.configuration;
			this.container = options.container;
			this.iteminfo = options.iteminfo;
			this.parentView = options.parentView;

			this.item = this.iteminfo.item

			this.qtyInBag = 0;

			var self = this
			,   itemType = this.item.itemtype
			,   qtyAvailableInv = this.item.custitem_qty_available_inv
			,   qtyAvailableKit = this.item.custitem_qty_available_kit
			

			this.availableStockforCurrentItem = 0

			/*this.availableStockforCurrentItemArray = []*/

			var liveOrder = LiveOrderModel.getInstance();
            //console.log(liveOrder.get('lines'))
            
            var lineData=liveOrder.get('lines').filter(function(line)
            {   
                return line.get('item').get('internalid') == self.item.internalid;
            });

            if(lineData.length > 0)
            {
	            var lineQuantity=lineData[0].get('quantity');
	            this.qtyInBag = lineQuantity;
            }

			if(itemType == "Kit")
			{
				this.availableStockforCurrentItem = qtyAvailableKit;
			}
			else if(itemType == 'InvtPart')
			{
				this.availableStockforCurrentItem = qtyAvailableInv;
			}

		}


	,   events: {
    	'click [data-action="show-qty-tool-tip"]': 'showQtyToolTip',
    	'click [data-action="update-bag-quantity"]': 'updateBagQuantity'
    }
    
    ,   showQtyToolTip: function showQtyToolTip(e){
    	
    	if($('.current-item-in-bag-tooltip-sec').hasClass('pdpttopened')){
			$('.current-item-in-bag-tooltip-sec').removeClass('pdpttopened')
		}
		else{
			$('.current-item-in-bag-tooltip-sec').addClass('pdpttopened');			
			/*$('.pdpttopened').css('transition-timing-function','ease');
			$('.pdpttopened').css('opacity','1');
			$('.pdpttopened').css('transform','translate3d(0px, -16px, 0px)');
			$('.pdpttopened').css('transition-duration','300ms');*/
		}
	   
    }	

    ,  updateBagQuantity: function updateBagQuantity(e){
    			var $element = jQuery(e.currentTarget);
				var currentQty = $element.attr('data-current-qty')
				//var oldQty = $element.attr('data-old-qty')
				var internalID=$element.attr("data-item-id");

				var cart = this.layout.application.getComponent('Cart');
				var lines = [];
				var liveOrder = LiveOrderModel.getInstance();
				var sendTracking = false;

				var self = this;

				var lineData=liveOrder.get('lines').filter(function(line)
	            {   
	                return line.get('item').get('internalid') == internalID;
	            });
	            var lineQuantity=lineData[0].get('quantity');

				//console.log(lineQuantity)
				if(currentQty == lineQuantity) 
				{
					//do nothing
				}
				else{
					if(currentQty == 0)
					{						
						liveOrder.removeLine(
                		lineData[0].set('quantity',parseFloat(lineQuantity)-1));               		
					}
					else{
						SC.loadingIndicatorShow();
	                	liveOrder.updateLine(
	                	lineData[0].set('quantity',parseFloat(currentQty)));	
	                	self.qtyInBag = currentQty;
	                	SC.loadingIndicatorHide();
	                    setTimeout(function(){
		                    if(!Utils.isPhoneDevice())
		                        jQuery('.header-mini-cart-menu-cart-link').dropdown("toggle");
		                }, 1000);                	
					}					
	                sendTracking = true;
				}


				/*if(sendTracking == true)
				{
	                //Snippet for GTM DataLayer
		            var cartLinesDL = liveOrder.get('lines')
		            ,   cartLinesModelsDL = cartLinesDL.models
		            ,   finalCartArray = []

		            _.each(cartLinesModelsDL, function(line) {
		                var lineItem = line.get('item')
		                ,   lineItemName = lineItem.get('displayname')
		                ,   lineItemSKU = lineItem.get('itemid')
		                ,   lineQty = line.get('quantity')
		                ,   lineRate = line.get('rate')

		                finalCartArray.push({
		                    'item': lineItemName,
		                    'quantity':  lineQty,
		                    'price': lineRate,
		                    'unique_id': lineItemSKU

		                })
		            });

		            const gtm = GoogleTagManager;
		            const eventName = 'cartInfo';
		             const eventData = {
		                event: eventName,
		                cartUpdates: finalCartArray
		             }
		             Tracker.trigger(eventName, eventData);
		             gtm.pushData(eventData);
		             console.log(gtm.win)
				}*/
				setTimeout(function(){
					console.log('refreshing')
                   self.render();
                   self.parentView.render();
                }, 1000); 
				
    }

    /*,   render : function()
	    {
	    	this._render();
	    } */

	, 	childViews: {

		}


		//@method getContext @return NXTurn.ShoppingExtensions.LoginRegister.View.Context
	,	getContext: function getContext()
		{
			var self = this
			,   availableStockforCurrentItemArray = []

			for(var a=1;a<=self.availableStockforCurrentItem;a++){
				availableStockforCurrentItemArray.push({
					new : a,
					isSelected : self.qtyInBag == a,
					itemid : self.item.internalid
				})
			}

			//console.log(this.item)

			return {
				availableStockforCurrentItemArray : availableStockforCurrentItemArray || [],
				qtyInBag : this.qtyInBag,
				itemId : this.item.internalid
			};
		}
	});
});
